export default __webpack_public_path__ + "static/media/_ic_more_come.16078609.svg";